module.exports = __webpack_public_path__ + "2f0394045f72944d7a692328b851f506.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/game-controller-s.png
// module id = 2032
// module chunks = 0